import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState, useCallback, useRef, memo } from 'react';
import toast from 'react-hot-toast';

import {
  IDia,
  IEjercicioItems,
} from '../../../../Interfaces/IMisRutinas';
import { IUserFromStorage } from '../../../../Interfaces/IUser';
import { guardarActualizarPesos, guardarPesosConDropset, obtenerPesos, obtenerPesosConDropset } from '../../../../Services/MisRutinas';
import CustomAccordion from '../../../../Components/CustomAccordion/CustomAccordion';
import AnotacionesDropset from './AnotacionesDropset';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';

import '../../../../Shared/css/MisRutinas/series.css';
import ModalInfoDropset from '../../../../Components/ModalInfo/ModalInfoDropset';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  ejercicio: IEjercicioItems;
  estado: string;
}

const Series = ({ ejercicio, isOpen, setIsOpen, estado }: Props) => {
  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  const [observaciones, setObservaciones] = useState(
    Array(ejercicio?.numeroSeries).fill('')
  );

  const [anotaciones, setAnotaciones] = useState(Array(3).fill(''));
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [rutinaEjercicioPesoID, setRutinaEjercicioPesoID] = useState([]);
  const [rutinaEjercicioPesoDropsetID, setRutinaEjercicioPesoDropsetID] = useState([]);
  const [isModalInfoDropsetOpen, setIsModalInfoDropsetOpen] = useState<boolean>(false);

  const handleOpenModalInfoDropset = () => {
    setIsModalInfoDropsetOpen(true);
  }

  const isMounted = useRef(true);

  let initialDataToSend = Array.from({ length: ejercicio?.numeroSeries }, (_, index) => ({
    fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
    serie: index + 1,
    descripcion: '',
    peso: 0,
  }));

  const [dataToSend, setDataToSend] = useState(initialDataToSend);
  const currentOrdenFinalizado = localStorage.getItem('currentOrdenFinalizado');
  const diaFromStorage: IDia = JSON.parse(localStorage.getItem('currentDiaSelected'));

  const canSave = diaFromStorage.estado !== '2' && diaFromStorage.orden === Number(currentOrdenFinalizado);

  const handleObservacionesChange = useCallback(
    (event, index) => {
      const updatedObservaciones = [...observaciones];
      updatedObservaciones[index] = event.target.value;
      setObservaciones(updatedObservaciones);
    },
    [observaciones]
  );

  const handleAnotacionesDropsetChange = useCallback(
    (event, index) => {
      const updatedAnotaciones = [...anotaciones];
      updatedAnotaciones[index] = event.target.value;
      setAnotaciones(updatedAnotaciones);
    },
    [anotaciones]
  );

  const dropsetAnotacionesToSend = (index) => {
    if(index === 2) return Array.from({ length: 3 }, (_, index) => ({
      fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
      serie: 3,
      descripcion: anotaciones[index] || '',
      fit4RutinaEjercicioPesoDropsetID: rutinaEjercicioPesoDropsetID[index] || 0,
    }))
    if(index === 3) return Array.from({ length: 3 }, (_, index) => ({
      fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
      serie: 3,
      descripcion: anotaciones[index] || '',
      fit4RutinaEjercicioPesoDropsetID: rutinaEjercicioPesoDropsetID[index] || 0,
    }))
    return []
  }

  const saveData = () => {
    let dataToSend = Array.from({ length: ejercicio?.numeroSeries }, (_, index) => ({
      fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
      serie: index + 1,
      descripcion: observaciones[index] || '',
    }));

    guardarActualizarPesos(dataToSend)
    .then(() => {
      toast.success('Guardado correctamente!');
      setIsOpen(false);
    });
  };
  
  const saveDataWithDropset = () => {
    let dataToSend = Array.from({ length: ejercicio?.numeroSeries }, (_, index) => ({
      fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
      serie: index + 1,
      descripcion: observaciones[index] || '',
      fit4RutinaEjercicioPesoID: rutinaEjercicioPesoID[index] || 0,
      dropsets: dropsetAnotacionesToSend(index)
    }));

    guardarPesosConDropset(dataToSend)
      .then(() => {
        toast.success('Guardado correctamente!');
        setIsOpen(false);
      })
  }

  useEffect(() => {
    isMounted.current = true;
    if (user && isOpen && isInitialLoad) {

      if( ejercicio.tipoEjercicio === 'E' ){
        obtenerPesos({
          fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
          fit4EjercicioID: ejercicio?.fit4EjercicioID,
          UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
        }).then((response) => {
          if (isMounted.current) {
            let newData = [];
            if (response.data.data.length > 0) {
              response.data.data.map((item: any) => {
                newData.push(item.descripcion);
              });
            }
            setObservaciones(newData);
            setIsInitialLoad(false);
          }
        });
      } else if ( ejercicio.tipoEjercicio === 'D' ) {
        obtenerPesosConDropset({
          fit4RutinaEjercicioID: ejercicio?.fit4RutinaEjercicioID,
          fit4EjercicioID: ejercicio?.fit4EjercicioID,
          UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
        }).then((response) => {
          if (isMounted.current) {
            let newData = [];
            let newDataID = [];
            let newAnotaciones = [];
            let newAnotacionesID = []
            if (response.data.data.length > 0) {
              response.data.data.map((item: any, index) => {
                newDataID.push(item.fit4RutinaEjercicioPesoID);
                newData.push(item.descripcion);
                if( item.dropsets.length > 0 ) {
                  item.dropsets.map((drop: any, index) => {
                    newAnotaciones.push(drop.descripcion);
                    newAnotacionesID.push(drop.fit4RutinaEjercicioPesoDropsetID);
                  })
                }
              });
            }
            setObservaciones(newData);
            setRutinaEjercicioPesoID(newDataID)
            setAnotaciones(newAnotaciones);
            setRutinaEjercicioPesoDropsetID(newAnotacionesID);
            setIsInitialLoad(false);
          }
        });
      }

    }
    return () => {
      isMounted.current = false;
    };

  }, [user, ejercicio, isOpen, isInitialLoad]);

  useEffect(() => {
    let newDataToSend = [...dataToSend];
    observaciones.forEach((observacion, index) => {
      newDataToSend[index] = {
        ...newDataToSend[index],
        descripcion: observacion,
      };
    });
    setDataToSend(newDataToSend);
  }, [observaciones]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      PaperProps={{
        sx: {
          borderRadius: '20px',
          maxWidth: '440px',
          width: '100%',
          margin: '16px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
          overflow: 'hidden',
        }
      }}
    >
      {/* Custom Header */}
      <div className="ser-header">
        <div className="ser-header-top">
          <button className="ser-close-btn" onClick={() => setIsOpen(false)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <p className="ser-exercise-name">{ejercicio?.ejercicio}</p>
        <div className="ser-stats-row">
          <div className="ser-stat-chip">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 4v16"/><path d="M18 4v16"/><path d="M6 12h12"/>
            </svg>
            {ejercicio?.numeroSeries} series
          </div>
          <div className="ser-stat-chip">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
            </svg>
            {ejercicio?.repeticiones} reps
          </div>
        </div>
      </div>

      <DialogContent sx={{ padding: 0 }}>
        <div className="ser-body">
          {/* Greeting + Instruction */}
          {user && (
            <p className="ser-greeting">
              {user.nombres}, anota tus pesos y como te sentiste en cada serie.
            </p>
          )}

          {/* Info Card */}
          <div className="ser-info-card">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
            <p>Para guardar tus anotaciones, el día anterior debe estar finalizado y este día aún sin finalizar.</p>
          </div>

          {/* Series Inputs */}
          <div className="ser-series-list">
            {[...Array(ejercicio?.numeroSeries)].map((_, index) => (
              <div className="ser-serie-item" key={index}>
                <div className="ser-serie-label">
                  <span className="ser-serie-number">{index + 1}</span>
                  Serie {index + 1}
                </div>
                <textarea
                  className="ser-textarea"
                  placeholder="Ej: 12kg × 12 reps, me sentí bien"
                  value={observaciones[index]}
                  onChange={(event) => handleObservacionesChange(event, index)}
                  maxLength={500}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck={false}
                  rows={2}
                />
                {ejercicio.tipoEjercicio === 'D' && index === 2 && (
                  <CustomAccordion>
                    <AccordionSummary
                      expandIcon={
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"/>
                        </svg>
                      }
                      sx={{
                        padding: '0 0.5rem',
                        minHeight: '36px',
                        '& .MuiAccordionSummary-content': { margin: '6px 0' },
                      }}
                    >
                      <div className="ser-dropset-trigger flex items-center">
                        <span>Dropset</span>
                        <button className="text-red-500 ml-1 flex items-center justify-center" onClick={handleOpenModalInfoDropset}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                          </svg>
                        </button>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: '0.25rem 0.5rem 0.5rem' }}>
                      <AnotacionesDropset
                        anotaciones={anotaciones}
                        handleAnotacionesDropsetChange={handleAnotacionesDropsetChange}
                      />
                    </AccordionDetails>
                  </CustomAccordion>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="ser-actions">
          <button
            className="ser-save-btn"
            onClick={() => {
              if( ejercicio.tipoEjercicio === 'E' ){
                saveData()
              } else if ( ejercicio.tipoEjercicio === 'D' ) {
                saveDataWithDropset()
              }
            }}
            disabled={!canSave}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Guardar
          </button>
          <button className="ser-cancel-btn" onClick={() => setIsOpen(false)}>
            Cerrar
          </button>
        </div>
      </DialogContent>

      <ModalInfoDropset 
        isOpen={isModalInfoDropsetOpen}
        setIsOpen={setIsModalInfoDropsetOpen}      
      />

    </Dialog>
  );
}

export default memo(Series);
